module.exports = "/_next/static/images/757ceb323e81bec3770b880811ffb609-sparkle.svg";